import Events from '../src/app/events'

export default function EventsPage() {
  return <Events />
}
